import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex } from 'antd';
import CustomButton from '../../components/UI/CustomButton/CustomButton';
import crmImage from '../../assets/images/garniture/crm.svg';
import styles from './Crm.module.scss';

export const Crm = () => {
  const navigate = useNavigate();

  return (
    <Flex className={styles.crmPage}>
      <div className={styles.crmPage__content}>
        <p className={styles.crmPage__title}>
          Do you want to import customers <br /> by connecting your CRM system?
        </p>
        <p className={styles.crmPage__subtitle}>You can always do this later in your profile settings</p>

        <img src={crmImage} alt="CRM" className={styles.crmPage__image} />

        <div className={styles.crmPage__buttons}>
          <CustomButton text="Yes, connect CRM" onClick={() => navigate('connect')} disable={false} />
          <button className={styles.crmPage__maybeLater} onClick={() => navigate('/')}>
            Maybe later
          </button>
        </div>
      </div>
    </Flex>
  );
};
